import {
  pagesWithTag,
  some,
  pagesWithoutBaseTag,
} from '../shared/utils/filter';

const onlyDepiPages = some([
  pagesWithoutBaseTag('Seite:'),
  pagesWithTag('Seite:DEPI'),
]);

export default onlyDepiPages;
